<template>
  <div class="content-wrapper intro-journey">
    <div class="d-flex align-items-center full-height justify-content-center">
      <div class="row">
        <div class="col-12" style="text-align: center">
          <h3 class="general-title text-center">The journey to owning a Passoni</h3>
          <div class="md-size-container" style="margin-bottom: 60px">
            <p class="general-content">
              Your journey to owning a Passoni started when you fell in love with cycling. In the next six simple stages your journey will be complete.
            </p>
          </div>
          <div class="journey-steps-container d-flex justify-content-around">
            <div class="journey-step">
              <div class="number">1</div>
              <h5>Questionnaire</h5>
              <div>
                <span class="general-content">
                  To ensure we build your perfect Passoni, we’ll ask you five short questions. These will help us determine the most suitable model for your cycling needs.
                </span>
              </div>
            </div>
            <div class="journey-step">
              <div class="number">2</div>
              <h5>Configuration</h5>
              <div>
                <span class="general-content">
                  With our innovative configurator you can build your Passoni from the frame up or refine one of our preset configurations.
                </span>
              </div>
            </div>
            <div class="journey-step">
              <div class="number">3</div>
              <h5>Confirmation</h5>
              <div>
                <span class="general-content">
                  Once completed, your configuration will be handled by the Passoni team. We confirm details, take a deposit and begin the build.
                </span>
              </div>
            </div>
            <div class="journey-step">
              <div class="number">4</div>
              <h5>The Build</h5>
              <div>
                <span class="general-content">
                  We’ll keep you updated on the build process at all the vital stages. We’ll send you images and videos of the welding, painting and finishing.
                </span>
              </div>
            </div>
            <div class="journey-step">
              <div class="number">5</div>
              <h5>Completion</h5>
              <div>
                <div class="general-content">
                  When the build is complete we will contact you to take the final payment. Once recieved we’ll arrange shipping or collection of your new Passoni.
                </div>
              </div>
            </div>
            <div class="journey-step">
              <div class="number">6</div>
              <h5>Delivery</h5>
              <div>
                <span class="general-content">
                  Your new Passoni will be delivered to your desired location. Our bikes arrive fully assembled and with a few minor adjustments you can hit the road.
                </span>
              </div>
            </div>
          </div>
          <button class="btn btn-outline-primary bottom-button" v-on:click="$emit('go-next')">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "intro-journey",
  data() {
    return {}
  }
}
</script>

<style lang="scss">
.journey-steps-container {
  margin-bottom: 40px;
  .journey-step {
    padding: 0 20px;
    width: 20%;
  }
  .number {
    border: 1px solid black;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    margin: 0 auto;
  }
  h5 {
    margin: 20px 0;
  }
}
</style>